import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { IoMapOutline /*, IoSettingsOutline */ } from 'react-icons/io5';

import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import style from './style.module.scss';

interface MenuItem {
  label: string;
  icon: React.ReactNode;
  path: string;
}

const SidebarMenu: React.FC = () => {
  const [selectedURL, setSelectedURL] = useState<string>('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setSelectedURL(location.pathname);
  }, [location]);

  const handleClick = (link: string): void => {
    navigate(link);
  };

  const menuItems: MenuItem[] = [
    {
      label: 'Planoo',
      icon: <IoMapOutline className={style.icon} />,
      path: '/app',
    },
    // {
    //   label: 'Settings',
    //   icon: <IoSettingsOutline className={style.icon} />,
    //   path: '/app/settings',
    // },
  ];

  return (
    <List className={style.menu}>
      {menuItems.map((item) => (
        <ListItemButton
          key={item.path}
          selected={selectedURL === item.path}
          onClick={() => handleClick(item.path)}
        >
          <ListItemIcon>{item.icon}</ListItemIcon>
          <ListItemText primary={item.label} />
        </ListItemButton>
      ))}
    </List>
  );
};

export default SidebarMenu;
